export const EXSBPOSITION_SHOW_RESET = 'EXSBPOSITION_SHOW_RESET'
export const EXSBPOSITION_SHOW_SET_ERROR = 'EXSBPOSITION_SHOW_SET_ERROR'
export const EXSBPOSITION_SHOW_SET_RETRIEVED = 'EXSBPOSITION_SHOW_SET_RETRIEVED'
export const EXSBPOSITION_SHOW_TOGGLE_LOADING = 'EXSBPOSITION_SHOW_TOGGLE_LOADING'
